module.exports = __webpack_public_path__ + "img/dot-vertical.3638e7d1.svg";